import apiClient from './client';

export interface MbcbReportListItem {
  id: number;
  reportMonth: number;
  reportYear: number;
  status: string;
}

export async function fetchMyMbcbReports(): Promise<MbcbReportListItem[]> {
  const res = await apiClient.get('/mbcb/reports/me');
  const { reports } = res.data.data as { reports: MbcbReportListItem[] };
  return reports ?? [];
}

export function getDefaultMinistryPeriod(): { reportMonth: number; reportYear: number } {
  const t = new Date();
  const ty = t.getFullYear();
  const tm = t.getMonth();
  if (tm === 0) return { reportMonth: 12, reportYear: ty - 1 };
  return { reportMonth: tm, reportYear: ty };
}

export async function createMyMbcbReport(period?: {
  reportMonth: number;
  reportYear: number;
}): Promise<{ id: number }> {
  const res = await apiClient.post('/mbcb/reports/me', period ?? {});
  return res.data.data as { id: number };
}
